import React from 'react';

const steps = [
  {
    num: '01',
    title: 'Set up your campaign',
    body: 'Choose your goal — outbound sales, lead follow-up, or research. Upload your contacts. Write a script or let AI generate one in seconds.',
  },
  {
    num: '02',
    title: 'AI starts calling',
    body: 'Hit launch. CallPilot dials your list and handles every conversation naturally — no voicemail fatigue, no off-days, no quota pressure.',
  },
  {
    num: '03',
    title: 'See results instantly',
    body: 'Every call is transcribed, sentiment-scored, and summarized. Get a clear view of who\'s interested and what to do next.',
  },
];

export function HowItWorks() {
  return (
    <section className="py-24 px-6">
      <div className="mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <span className="text-xs font-mono tracking-widest uppercase text-indigo-400 mb-3 block">How it works</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
            Up and calling in under 5 minutes
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 relative">
          {steps.map((step, i) => (
            <div key={step.num} className="relative flex flex-col items-start px-8 py-8">
              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[calc(50%+2rem)] right-0 h-px bg-gradient-to-r from-white/[0.12] to-transparent" />
              )}

              {/* Number badge */}
              <div className="w-10 h-10 rounded-full border border-indigo-500/30 bg-indigo-500/10 flex items-center justify-center font-mono text-sm text-indigo-400 mb-5 shrink-0">
                {step.num}
              </div>

              <h3 className="text-lg font-bold text-white mb-2">{step.title}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
